export default (number) => {
  const converted = Number(number);
  return Number.isFinite(Number(converted)) ? converted : 0;
};
